import { Button } from '@/components/Button'
import { useEffect, useState } from 'react'
import { BiLeftArrowAlt } from 'react-icons/bi'

import { HEADINGS } from '../../data/headings'

import './styles.scss'

type StepperProps = {
  totalSteps: number
  currentStep: number
  onBack: () => void
  onGoToStep: (step: number) => void
}

export function Stepper({
  totalSteps,
  currentStep,
  onBack,
  onGoToStep,
}: StepperProps) {
  const [direction, setDirection] = useState<'forward' | 'backward'>('forward')
  const [prevStep, setPrevStep] = useState(currentStep)

  useEffect(() => {
    if (currentStep !== prevStep) {
      setDirection(currentStep > prevStep ? 'forward' : 'backward')
      setPrevStep(currentStep)
    }
  }, [currentStep, prevStep])

  return (
    <div className="stepper" data-direction={direction}>
      <ol className="stepper__steps">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const stepNumber = index + 1
          const isPast = stepNumber < currentStep
          const isActive = stepNumber === currentStep
          const title = HEADINGS[index]?.title

          return (
            <li
              key={stepNumber}
              className={`stepper__step ${isPast ? 'past' : isActive ? 'active' : ''}`.trim()}
              aria-current={isActive ? 'step' : undefined}
            >
              {/* Só as etapas já concluídas viram atalho: voltar é seguro,
                  avançar pularia a validação de cada etapa. */}
              {isPast ? (
                <button
                  type="button"
                  className="stepper__step__link"
                  onClick={() => onGoToStep(stepNumber)}
                >
                  <span className="sr-only">
                    Voltar para a etapa {stepNumber}
                    {title ? `: ${title}` : ''}
                  </span>
                </button>
              ) : (
                <span className="sr-only">
                  Etapa {stepNumber}
                  {title ? `: ${title}` : ''}
                  {isActive ? ' (etapa atual)' : ''}
                </span>
              )}

              <span className="stepper__step__bar" aria-hidden />
            </li>
          )
        })}
      </ol>

      <div className="stepper__legend">
        <p>
          <span className="step-number">Etapa {currentStep}</span> de{' '}
          {totalSteps}
        </p>
      </div>

      <div className="stepper__back" data-visible={currentStep !== 1}>
        <Button
          className="stepper__back__button"
          text="Voltar etapa"
          variant="primary"
          leftRender={<BiLeftArrowAlt aria-hidden />}
          onClick={onBack}
        />
      </div>
    </div>
  )
}
